import { styled } from '@mui/material/styles'
import MuiButton from '@mui/material/Button'

export const ButtonAction = styled(MuiButton, {
  name: 'ButtonAction',
  slot: 'Root',
  skipSx: true,
})`
  width: 77px;
  height: 42px;
  borderradius: 4px;
`
